import { ERROR_FALLBACKS, GENERIC_FALLBACK } from './errorFallbacks';
import useFetchErrorContent from './useFetchErrorContent';
import useMarketInfo from '../../hooks/useMarketInfo';

const useFetchErrorByKey = (key: string): string => {
  const { language } = useMarketInfo();
  const normalizedKey = key.toLowerCase();

  const { data } = useFetchErrorContent(normalizedKey);
  const { data: genericData } = useFetchErrorContent('generic_error');

  const messageFromApi = data?.message;

  const languageFallbacks = ERROR_FALLBACKS[language] || {};
  const messageFromConfig = languageFallbacks[normalizedKey];

  const genericError = genericData?.message || GENERIC_FALLBACK[language] || '';

  return messageFromApi || messageFromConfig || genericError || '';
};

export default useFetchErrorByKey;
